document.addEventListener("DOMContentLoaded", () => {
  const radioButtons = document.querySelectorAll('.variant-radio-option');
  const variantSelect = document.querySelector('select[name="id"][data-js-product-variants]');
  const widthInput = document.getElementById("wallWidth");
  const heightInput = document.getElementById("wallHeight");
  const widthUnit = document.getElementById("widthUnit");
  const heightUnit = document.getElementById("heightUnit");
  const calculatedAreaDisplay = document.getElementById("calculatedArea");
  const priceDisplayElement = document.querySelector(".custom-price-display");
  const minRequirementDisplay = document.getElementById("minRequirement");
  const panelDisplayElement = document.querySelector(".panel-display");
  const variantId = document.querySelector("#customVariantId");
  const variantQuantity = document.querySelector("#customQuantity");
  const setHeight = document.querySelector("#hiddenHeight");
  const setWidth = document.querySelector("#hiddenWidth");

  const sethiddenColors = document.querySelector("#hiddenColors");
  const sethiddenColors2 = document.querySelector("#hiddenColors2");

  const MAX_SQUARE_FEET = Number(document.querySelector(".custom-wall-dimensions").dataset.minSq) || 10;
  const MAX_FEET_HEIGHT = Number(document.querySelector(".custom-wall-dimensions").dataset.maxHeight) || 15;
  let pricePerSquareFoot = parseFloat(document.querySelector(".variant-radio-option:checked").dataset.price) || 0;
  const maxHeightErrorText = document.querySelector(".custom-wall-dimensions").dataset.errorText;
  const addToCartButton = document.querySelector("#customAddToCart");
  const nextButtonFirst = document.querySelector("#second-step-next");
  const maxHeightErrorElement = document.querySelector(".max-height-error");
  function formatPrice(price) {
    return Shopify.formatMoney(price, theme.moneyFormat);
  }

  function getUnitMultiplier(unit) {
    return unit === "in" ? 1 / 12 : unit === "cm" ? 0.0328084 : 1;
  }

  function convertToFeet(value, unit) {
    return value * getUnitMultiplier(unit);
  }
 // console.log(variantSelect);
  function calculatePanels(height, width, unit = 'ft') {
    
    let heightInFeet = Math.max(convertToFeet(height, unit), 1);

    if (heightInFeet > MAX_FEET_HEIGHT) {
      return `${maxHeightErrorText}`;
    }

    const panels = Math.ceil(Math.max(convertToFeet(width, unit), 2) / 2);
    return `You will receive ${panels} panels, each 2 feet wide and ${heightInFeet.toFixed(2)} feet tall.`;
  }

  function updateRequirementDisplay(unit) {
    const multiplier = unit === "in" ? 144 : unit === "cm" ? 929.03 : 1;
    minRequirementDisplay.textContent = `${(MAX_SQUARE_FEET * multiplier).toFixed(2)} ${unit === "in" ? "Square Inches" : unit === "cm" ? "Square Centimeters" : "Square Feet"}`;
  }

  function displayResults(displayArea, unitLabel, totalPrice, comparePrice) {
    calculatedAreaDisplay.textContent = `${displayArea.toFixed(2)} ${unitLabel}`;
    priceDisplayElement.innerHTML = `<span class="price">${formatPrice(totalPrice)}</span>` + (comparePrice > 0 ? `<span class="price price--sale">${formatPrice(comparePrice)}</span>` : '');
  }

  function calculateAndDisplayResults() {
    const widthValue = parseFloat(widthInput.value) || 0;
    const heightValue = parseFloat(heightInput.value) || 0;
    if (!widthValue || !heightValue) {
      nextButtonFirst.disabled = true;  
      return;
    }
   
    
    const unit = widthUnit.value;
    const widthInFeet = convertToFeet(widthValue, unit);
    const heightInFeet = convertToFeet(heightValue, unit);
    const areaInSquareFeet = Math.ceil(widthInFeet * heightInFeet);
    const totalPrice = areaInSquareFeet * pricePerSquareFoot;
    const comparePrice = parseFloat(document.querySelector('.variant-radio-option:checked')?.dataset.comparePrice) * areaInSquareFeet || -1;
    variantQuantity.value = areaInSquareFeet; 
    setWidth.value = unit === "ft" 
      ? `${widthInFeet} ft` 
      : unit === "in" 
      ? `${widthValue} in` 
      : `${widthValue} cm`;
  
    setHeight.value = unit === "ft" 
      ? `${heightInFeet} ft` 
      : unit === "in" 
      ? `${heightValue} in` 
      : `${heightValue} cm`;

    // set hidden svg and color table
    // If window.svg_global is an SVG element (DOM object)
    if (window.svg_global) {
      if (sethiddenColors) {
        sethiddenColors.value = JSON.stringify(window.validColorClasses);
      };
      if (sethiddenColors2) {
        sethiddenColors2.value = JSON.stringify(window.validColorClasses);
      };
    };

    displayResults(
      unit === "ft" ? areaInSquareFeet : unit === "in" ? areaInSquareFeet * 144 : areaInSquareFeet * 929.03,
      unit === "ft" ? "Square Feet" : unit === "in" ? "Square Inches" : "Square Centimeters",
      totalPrice,
      comparePrice
    );
    const heightExceedsMax = heightInFeet > MAX_FEET_HEIGHT;
    const areaBelowMin = areaInSquareFeet < MAX_SQUARE_FEET;
    
    panelDisplayElement.classList.toggle("error", heightExceedsMax);
    maxHeightErrorElement.classList.toggle("active", heightExceedsMax);
    
    const disableActions = heightExceedsMax || areaBelowMin;
    addToCartButton.disabled = disableActions;
    nextButtonFirst.disabled = disableActions;

    
    panelDisplayElement.innerHTML = calculatePanels(heightValue, widthValue, unit);
    updateRequirementDisplay(unit);
  }

  function syncUnits(newUnit) {
    widthUnit.value = newUnit;
    heightUnit.value = newUnit;
    calculateAndDisplayResults();
  }

  widthUnit.addEventListener("change", () => syncUnits(widthUnit.value));
  heightUnit.addEventListener("change", () => syncUnits(heightUnit.value));

  radioButtons.forEach(radio => {
    radio.addEventListener('change', function () {
      if (this.checked) {
        variantSelect.value = this.value;
        pricePerSquareFoot = parseFloat(this.dataset.price) || 0;
        variantId.value = this.value; 
        calculateAndDisplayResults();
        variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  });

  [widthInput, heightInput].forEach(input => {
    input.addEventListener("input", () => {
      if (input.value < 0) input.value = "";
      calculateAndDisplayResults();
    });
  });


  // Accordions 

  const steps = document.querySelectorAll(".accordion-item");
  const nextButtons = document.querySelectorAll(".next-step");
  const prevButtons = document.querySelectorAll(".prev-step");
  const stepContainer = document.querySelector(".accordion");
  let currentStep = 0;

  function showStep(index) {
    steps.forEach((step, i) => {
      step.classList.toggle("visible", i === index);
      step.style.transform = `translateX(${(i - index) * 100}%)`;
    });
    adjustContainerHeight();
  }

  function navigateStep(direction) {
    if (direction === "next" && currentStep < steps.length - 1) {
      currentStep++;
    } else if (direction === "prev" && currentStep > 0) {
      currentStep--;
      if (window.svg_global) {
        if (stepContainer) {
          if (!window.validColorClasses) {
            stepContainer.style.height = "300px";
            return ;
          }
          if (Object.entries(window.validColorClasses).length > 10) {
            stepContainer.style.height = "400px";
          } else if (Object.entries(window.validColorClasses).length > 5) {
            stepContainer.style.height = "300px";
          } else {
            stepContainer.style.height = "200px";
          }
        };
      } else {
        stepContainer.style.height == "300px";
      }
    }
    showStep(currentStep);
  }
  function adjustContainerHeight() {
    const visibleStep = steps[currentStep];
    if (currentStep > 0) { 
      stepContainer.style.height = visibleStep.scrollHeight + 30 + "px";
    }
  }
  nextButtons.forEach((btn) => btn.addEventListener("click", () => navigateStep("next")));
  prevButtons.forEach((btn) => btn.addEventListener("click", () => navigateStep("prev")));

  showStep(currentStep);

  window.updateColors = async function () {
    if (window.svg_global) {
      if (sethiddenColors) {
        sethiddenColors.value = JSON.stringify(window.validColorClasses);
      };
      if (sethiddenColors2) {
        sethiddenColors2.value = JSON.stringify(window.validColorClasses);
      };
    };
  };  

  // Custom Take user to Cart
  document.addEventListener('theme:cart::added', (event) => {
    const button = event.detail.button;
    console.log("taking user to cart");
    // Check if the button has the specific ID (e.g., 'customAddToCart')
    console.log(button, event);
    if (button.id === 'customAddToCart') {
      window.location.href = '/cart';
    }
  });

  
});
